import TableChartSidebar from 'components/Table/TableChartSidebar';
import { PitcherReportChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';
import { ChartConfigProps } from 'utilities/chartIdToComponent';

const PitcherBallTrackingStatsChartSidebar = (props: ChartConfigProps<TableChartConfigDto, PitcherReportChartConfigDto>) => {
  return <TableChartSidebar chartId='PitcherBallTrackingStatsChart' configKey='pitcherBallTrackingStatsChartConfig' {...props} />;
};

export default PitcherBallTrackingStatsChartSidebar;
